/**
 * Whether rich-text HTML has anything worth rendering.
 *
 * - Empty Quill shells (`<p><br></p>`, `<p></p>`) → false
 * - Real copy → true
 * - Intentional spacing only (spaces, tabs, &nbsp;, etc.) → true
 *
 * Spaces are preserved in the check (we no longer strip them). Tags that carry
 * no text and no space entities are ignored.
 */
export const hasRichTextContent = (html) => {
  if (typeof html !== "string" || html.length === 0) return false;

  // Turn space-like entities into real spaces before stripping tags
  const withSpaces = html
    .replace(/&nbsp;/gi, " ")
    .replace(/&#160;/gi, " ")
    .replace(/&#x0*a0;/gi, " ")
    .replace(/&ensp;/gi, " ")
    .replace(/&emsp;/gi, " ")
    .replace(/&thinsp;/gi, " ");

  // Drop tags. Do not trim or remove remaining whitespace.
  // <br> / empty wrappers leave nothing behind → unused shell.
  // "  ", "&nbsp;", and real words remain → used.
  const withoutTags = withSpaces.replace(/<[^>]+>/g, "");

  // Decode a few common entities so "&amp;" etc. still count as content
  const plain = withoutTags
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&apos;/gi, "'");

  // Any remaining character counts — including spaces used for indent/gaps
  return plain.length > 0;
};

const useItemIsUsed = () => hasRichTextContent;

export default useItemIsUsed;
